// allow customize loading via theme slots or ./dumi/loading.tsx
export { default } from 'dumi/theme/slots/Loading';